import qyglGetter from '../getters/qyglGetter'
import qyglAction from '../actions/qyglAction'
import qyglMutation from '../mutations/qyglMutation'

const qyglModule = {
    state: {
        learnWeixinPayCode: {},
        learnWeixinPayResult: {},
        enterpriseEmployee: {},
        enterpriseApprove: {},
        learningmgtQY: {},
        makeUpLearnDetails: {},
        enterpriseMakeUpApprove: {},
        enterprise: {},
        cmType: [],
        cmJob: [],
        cmCertificate: {},
        cmCertificateDetails: {},
        remoteCmCertificate: [],
        cmEmployee: {},
        cmEmployeeDetails: {},
        cmProject: {},
        cmProjectDetails: {},
        approveLearns: {},
        invoiceApproves: {},
        lastInvoiceApprove: {},
        invoiceApproveStates: [],
        bdyTestBatchEmployees: {},
        bdyTestBatchAddEmployees: {},
        selectBdyTestSessions: [],

        enterpriseModifyApproves: {},
        enterpriseModifyApproveStates: [],

        bdyPracticeEnrollAddEmployees: [],

        zjyTestBatchAddEmployees: {}
    },
    getters: qyglGetter,
    actions: qyglAction,
    mutations: qyglMutation
}

export default qyglModule;



// WEBPACK FOOTER //
// ./src/store/jzjy/modules/qyglModule.js